
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { AdminAuthProvider, useAdminAuth } from '@/contexts/AdminAuthContext';
import { Toaster } from 'sonner';
import { AdminRoute } from '@/components/AdminRoute';
import AdminLogin from '@/pages/admin/Login';
import AdminDashboard from '@/pages/admin/Dashboard';
import ComplianceDashboard from '@/pages/admin/ComplianceDashboard';
import Documents from '@/pages/admin/documents/Documents';
import NotFound from '@/pages/NotFound';
import Users from '@/pages/admin/Users';
import Settings from '@/pages/admin/Settings';
import EmailTemplates from '@/pages/admin/EmailTemplates';
import EmailTemplateEditor from '@/pages/admin/EmailTemplateEditor';
import Certificates from '@/pages/admin/Certificates';
import CertificatesReports from '@/pages/admin/certificates/Reports';
import CertificatesManage from '@/pages/admin/certificates/Manage';
import CertificatesTemplates from '@/pages/admin/certificates/Templates';
import CertificatesAnalytics from '@/pages/admin/certificates/Analytics';
import CertificatesInventory from '@/pages/admin/certificates/Inventory';
import CertificatesRetention from '@/pages/admin/certificates/Retention';
import Reviews from '@/pages/admin/Reviews';
import Discounts from '@/pages/admin/Discounts';
import Courses from '@/pages/admin/Courses';
import ChatLogs from '@/pages/admin/ChatLogs';

function RootRedirect() {
  const { isAdmin, isLoading } = useAdminAuth();
  
  if (isLoading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }
  
  return <Navigate to={isAdmin ? "/dashboard" : "/login"} replace />;
}

function App() {
  return (
    <ThemeProvider>
      <AdminAuthProvider>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<AdminLogin />} />
          <Route path="/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/compliance" element={<AdminRoute><ComplianceDashboard /></AdminRoute>} />
          <Route path="/documents" element={<AdminRoute><Documents /></AdminRoute>} />
          <Route path="/users" element={<AdminRoute><Users /></AdminRoute>} />
          <Route path="/users/:id" element={<AdminRoute><Users /></AdminRoute>} />
          <Route path="/certificates" element={<AdminRoute><Certificates /></AdminRoute>} />
          <Route path="/reports" element={<Navigate to="/certificates/reports" replace />} />
          <Route path="/certificates/reports" element={<AdminRoute><CertificatesReports /></AdminRoute>} />
          <Route path="/certificates/manage" element={<AdminRoute><CertificatesManage /></AdminRoute>} />
          <Route path="/certificates/templates" element={<AdminRoute><CertificatesTemplates /></AdminRoute>} />
          <Route path="/certificates/analytics" element={<AdminRoute><CertificatesAnalytics /></AdminRoute>} />
          <Route path="/certificates/inventory" element={<AdminRoute><CertificatesInventory /></AdminRoute>} />
          <Route path="/certificates/retention" element={<AdminRoute><CertificatesRetention /></AdminRoute>} />
          <Route path="/reviews" element={<AdminRoute><Reviews /></AdminRoute>} />
          <Route path="/discounts" element={<AdminRoute><Discounts /></AdminRoute>} />
          <Route path="/courses" element={<AdminRoute><Courses /></AdminRoute>} />
          <Route path="/courses/:id" element={<AdminRoute><Courses /></AdminRoute>} />
          <Route path="/chatlogs" element={<AdminRoute><ChatLogs /></AdminRoute>} />
          <Route path="/settings" element={<AdminRoute><Settings /></AdminRoute>} />
          <Route path="/email-templates" element={<AdminRoute><EmailTemplates /></AdminRoute>} />
          <Route path="/email-templates/:id" element={<AdminRoute><EmailTemplateEditor /></AdminRoute>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster />
      </AdminAuthProvider>
    </ThemeProvider>
  );
}

export default App;
